module.exports = __webpack_public_path__ + "static/media/jarvis.ec0eb78d.png";